// SWA built-in auth
export const getUser = async () => {
  // Check custom JWT first
  const token = localStorage.getItem('tripvibe_token');
  if (token) {
    try {
      const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(base64));
      if (payload.exp * 1000 > Date.now()) {
        return { userId: payload.userId, userDetails: payload.username, identityProvider: 'custom' };
      }
      localStorage.removeItem('tripvibe_token');
    } catch {
      localStorage.removeItem('tripvibe_token');
    }
  }

  // Fall back to SWA auth (Microsoft)
  try {
    const res = await fetch('/.auth/me');
    const data = await res.json();
    return data.clientPrincipal || null;
  } catch {
    return null;
  }
};

export const login = () => {
  window.location.href = '/.auth/login/aad';
};

export const logout = () => {
  localStorage.removeItem('tripvibe_token');
  window.location.href = '/.auth/logout';
};

// Custom auth
export const customLogin = async (username, password) => {
  const res = await fetch('/api/auth/login', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (!res.ok) {
    if (data.requiresVerification) return { requiresVerification: true, userId: data.userId };
    throw new Error(data.error || 'Login failed');
  }
  localStorage.setItem('tripvibe_token', data.token);
  return data;
};

export const customRegister = async (username, password) => {
  const res = await fetch('/api/auth/register', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username, password }),
  });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Registration failed');
  localStorage.setItem('tripvibe_token', data.token);
  return data;
};
